//
//
//
//
//
//

const IMG_STATE = {
    empty_building: "https://cdn.vip-wifi.com/fangchan/img/icons/building.png",
    empty_page: "https://cdn.vip-wifi.com/fangchan/img/icons/empty_state.png",
}
export default {
    computed: {
        img_src() {
            return IMG_STATE[this.type]
        }
    },
    props: {
        top: Number,
        type: {
            type: String,
            default: "empty_building"
        },
        desc: {
            type: String,
            default: "空空如也，去其他楼盘看看吧～"
        }
    }
}
